import cc from 'classcat';
import React, { ReactElement, useEffect, useRef, useState } from 'react';
import C from './CommunityDashboardHeader.css';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import IconButton from '@mui/material/IconButton';
import { LightTooltip } from 'components/min-sidebar-community-list/MinSidebarCommunityList';

export default function HorizontalCarousal({
  list = [],
  className,
  bigIcon,
}: {
  list: { id: string; tooltip?: string; child: ReactElement }[];
  className?: string;
  bigIcon?: boolean;
}) {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [listOverflowing, setListOverflowing] = useState({
    left: true,
    right: true,
  });

  useEffect(() => {
    window.addEventListener('resize', updateListOverflowing);

    setListOverflowing({
      left: false,
      right: false,
    });

    return () => window.removeEventListener('resize', updateListOverflowing);
  }, []);

  useEffect(() => {
    updateListOverflowing();
  }, [list]);

  const updateListOverflowing = () => {
    const el = containerRef.current;
    if (!el) return;
    if (el.scrollWidth - el.getBoundingClientRect().width > 5) {
      return setListOverflowing({
        left: el.scrollLeft > 0,
        right: true,
      });
    }
  };

  return (
    <>
      <>
        {listOverflowing.left && (
          <div className={cc([C.overflowBtns, C.left])}>
            <IconButton
              className={cc({
                [C.scrollBtn]: true,
                [C.big]: bigIcon,
              })}
              onClick={() => {
                const el = containerRef.current;
                if (!el) return;
                const scrollLeft = el.scrollLeft - 120;
                el.scrollTo({
                  left: scrollLeft,
                  behavior: 'smooth',
                });
                setListOverflowing((o) => ({
                  ...o,
                  right:
                    scrollLeft + el.getBoundingClientRect().width <
                    el.scrollWidth,
                }));

                if (scrollLeft <= 0) {
                  setListOverflowing((o) => ({
                    ...o,
                    left: false,
                  }));
                }
              }}
            >
              <ChevronLeftIcon />
            </IconButton>
          </div>
        )}
        <div className={C.memberListOuter} ref={containerRef}>
          <div className={cc([C.memberList, className])}>
            {list.map((item) => {
              return item.tooltip ? (
                <LightTooltip
                  title={item.tooltip}
                  arrow
                  placement='bottom'
                  key={item.id}
                >
                  <span>{item.child}</span>
                </LightTooltip>
              ) : (
                <span key={item.id}>{item.child}</span>
              );
            })}
          </div>
        </div>
        {listOverflowing.right && (
          <div className={cc([C.overflowBtns, C.right])}>
            <IconButton
              className={cc({
                [C.scrollBtn]: true,
                [C.big]: bigIcon,
              })}
              onClick={() => {
                const el = containerRef.current;
                if (!el) return;
                const scrollLeft = el.scrollLeft + 120;
                el.scrollTo({
                  left: scrollLeft,
                  behavior: 'smooth',
                });
                setListOverflowing((o) => ({
                  ...o,
                  left: true,
                }));
                if (
                  scrollLeft + el.getBoundingClientRect().width >=
                  el.scrollWidth - 5
                ) {
                  setListOverflowing((o) => ({
                    ...o,
                    right: false,
                  }));
                }
              }}
            >
              <ChevronRightIcon />
            </IconButton>
          </div>
        )}
      </>
    </>
  );
}

const OnlineIndicator = () => (
  <div
    style={{
      border: '2px solid var(--color-base)',
      borderRadius: '10px',
      position: 'absolute',
      bottom: 0,
      right: '-5px',
    }}
  >
    <div
      style={{
        border: '4px solid #00b050',
        height: 0,
        width: 0,
        borderRadius: '4px',
      }}
    />
  </div>
);
